import React from 'react';
import Options from '../Components/layouts/option/Options';


function FeaturesPage() {
	return (
		<div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
			<Options />
		</div>
	);
}

export default FeaturesPage;
